import { BaseDto } from "@/shared/dtos/base-dto";

export class canales_entrada extends BaseDto {
  public codigo: string = "";
  public nombre: string = "";
  public bloquea_agenda: boolean = true;
  public activo: boolean = true;

  constructor(data?: any) {
    super();
    if (!data) return;
    this.copy(data);
  }
}
